var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import InstoreDiscountsInstructions from './InstoreDiscounts';
import InstorePosterInstructions from './InstorePoster';
import InstoreReceiptInstructions from './InstoreReceipt';
import InstoreSMSInstructions from './InstoreSMS';
const InstoreInstructions = (_a) => {
    var { hasDiscounts } = _a, business = __rest(_a, ["hasDiscounts"]);
    return (_jsxs("div", { className: "instore-instructions", children: [_jsx(InstorePosterInstructions, Object.assign({}, business)), _jsx(InstoreReceiptInstructions, Object.assign({}, business)), _jsx(InstoreSMSInstructions, Object.assign({}, business)), hasDiscounts && _jsx(InstoreDiscountsInstructions, Object.assign({}, business))] }));
};
export default InstoreInstructions;
